<template>
    <div class="sammio-actions d-print-none" id="sammio__element--actions">
        <div class="container">
            <div :class="getMainContainerClasses">
                <div v-if="isMobile" class="sammio-actions__icon col-12 col-md-4">
                    <v-btn
                        class="p-0 btn-link border-0 text-black mr-2 "
                        @click.stop="getDrawerStatus(drawerStatus = !drawerStatus)"
                    >
                            <menu-icon size="1.5x" class="sammio-actions__icon icon__stroke--green"></menu-icon>
                            <span>{{ mobileMenuButtonText }}</span>
                    </v-btn>
                </div>
                <div class="row sammio-actions__container">
                    <v-btn
                            v-if="isRouteBookmarks"
                            id="bookmarks-reorder"
                            class="sammio-actions__item vertical-align-top"
                            @mouseover="isHovering = 'bookmarksReorder'"
                            @mouseleave="isHovering = ''"
                            @focus="isHovering = 'bookmarksReorder'"
                            @click="onClickBookmarksReorder"
                            :disabled="getBookmarks.length < 2"

                    >
                        <span v-if="(isHovering === 'bookmarksReorder') || getBookmarksReorderActive">
                            <edit-icon size="1.35x" class="sammio-actions__icon icon__stroke--green icon__filled--yellow"></edit-icon>
                        </span>
                        <span v-else>
                            <edit-icon size="1.35x" class="sammio-actions__icon icon__stroke--green"></edit-icon>
                        </span>
                        {{$t('sammio.bookmarks.reorder')}}
                    </v-btn>
                    <v-btn
                            v-if="isRouteBookmarks"
                            class="sammio-actions__item"
                            @mouseover="isHovering = 'download'"
                            @mouseleave="isHovering = ''"
                            @focus="isHovering = 'download'"
                            @click="onClickDownload"
                            :disabled="downloadButtonClicked || (getBookmarks.length === 0)"
                    >
                        <span v-if="isHovering === 'download'">
                            <sammio-icon-download-hover icon-css-class="sammio-actions__icon"></sammio-icon-download-hover>
                        </span>
                        <span v-else>
                          <sammio-icon-download  icon-css-class="sammio-actions__icon"></sammio-icon-download>
                        </span>{{$t('sammio.export_pdf')}}
                    </v-btn>
                    <v-btn
                        class="sammio-actions__item"
                        v-on:click="printPage()"
                        @mouseover="isHovering = 'print'"
                        @mouseleave="isHovering = ''"
                        @focus="isHovering = 'print'"
                    >
                        <span v-if="isHovering === 'print'">
                          <sammio-icon-print-highlight  icon-css-class="sammio-actions__icon"></sammio-icon-print-highlight>

                       </span>
                      <span v-else class="sammio-actions__icon">
                         <sammio-icon-print></sammio-icon-print>
                      </span>{{$t('sammio.print')}}
                    </v-btn>
                    <v-btn
                            class="sammio-actions__item"
                            @mouseover="isHovering = 'share'"
                            @mouseleave="isHovering = ''"
                            @focus="isHovering = 'share'"
                            @click="onClickShare"
                            id="shareButton"
                            :disabled="(isRouteBookmarks && (getBookmarks.length === 0)) || shareButtonClicked"
                            aria-haspopup="true"
                            ref="buttonShare"
                    >
                        <sammio-icon-share-highlight v-if="isHovering === 'share'" icon-css-class="sammio-actions__icon"></sammio-icon-share-highlight>
                        <sammio-icon-share v-else icon-css-class="sammio-actions__icon"></sammio-icon-share>
                        {{$t('sammio.share')}}
                    </v-btn>
                    <sammio-modal
                        :show-modal="showShareTooltip"
                        type="inline"
                        pointer = "top-right"
                        v-click-outside="onClickOutsideModal"
                        id="modalShare"
                    >
                      <template #content>
                          <input
                            ref="shareCopyInput"
                            @click="selectText"
                            type="text"
                            readonly
                            :value="shareInputText"
                            tabindex="-1"
                          />
                      </template>
                      <template #actions>
                        <v-btn
                            ref="shareCopyButton"
                            class="btn btn-primary"
                            @click="onClickCopy"
                        >
                          {{ $t('sammio.copy') }} <span class="sr-only">{{ $t('sammio.link_to_page') }}{{ shareInputTextReadable }}</span>
                        </v-btn>
                      </template>
                    </sammio-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Share2Icon, MenuIcon, EditIcon} from 'vue-feather-icons'
    import SammioIconDownload from "./icons/Download";
    import SammioIconDownloadHover from "./icons/DownloadHighlight";
    import SammioIconPrint from "./icons/Print";
    import SammioIconPrintHighlight from "./icons/PrintHighlight";
    import SammioIconShare from "./icons/Share"
    import SammioIconShareHighlight from "./icons/ShareHighlight";
    import SammioModal from "./SammioModal";
    import { i18n } from "../translations/i18n";
    import * as http from "../store/http";
    import {getStorableBookmarks} from "../store/helpers";
    import { mapGetters } from 'vuex'

    export default {
        name: "SammioActions",
        props: ['isMobile', 'status','mobileNavText'],
        data() {
            return {
                drawerStatus: this.status,
                hover: "",
                showShareTooltip: false,
                shareButtonClicked: false,
                copyButtonClicked: false,
                downloadButtonClicked: false,
                timeoutHandle: ''
            }
        },
        components: {
            Share2Icon,
            MenuIcon,
            SammioIconDownload,
            SammioIconDownloadHover,
            SammioIconPrint,
            SammioIconPrintHighlight,
            SammioIconShare,
            SammioIconShareHighlight,
            EditIcon,
            SammioModal
        },
        computed: {
            ...mapGetters([
                'getBookmarksShortUrl',
                'getBookmarks',
                'getBookmarkName',
                'getBookmarksReorderActive'
            ]),
            getMainContainerClasses() {
                let classNames = ''
                if (this.isMobile) {
                    classNames = 'row'
                }
                return classNames
            },
            isHovering: {
              get: function() {
                return this.hover
              },
              set: function(newValue) {
                this.hover = newValue
              }
            },
            mobileMenuButtonText() {
                  return this.$t('sammio.navigation.' + this.mobileNavText)
            },
            isRouteBookmarks() {
                return this.$router.currentRoute.name && this.$router.currentRoute.name.startsWith('bookmarks')
            },
            isRouteSearch() {
                return this.$router.currentRoute.name && this.$router.currentRoute.name.startsWith('search')
            },
            shareInputText() {
                if (this.copyButtonClicked) {
                    return i18n.t('sammio.url_copied_to_clipboard')
                } else {
                    if (this.isRouteBookmarks) {
                        const queryParams = this.$router.currentRoute.query
                        let bookmarksPath = this.$router.options.routes.filter(route => route.name === 'bookmarks')[0].path
                        let url =`${window.location.origin}/#${bookmarksPath}/${this.getBookmarksShortUrl}`
                        let separator = '?'
                        for (const param of Object.keys(queryParams)) {
                            url += separator + param + '=' + queryParams[param]
                            separator = '&'
                        }
                        return url.toString()
                    } else {
                        return window.location.href
                    }
                }
            },
            shareInputTextReadable() {
                return document.title;
            },
        },
        methods: {
            onClickBookmarksReorder() {
                const value = !this.getBookmarksReorderActive
                this.$store.dispatch('setBookmarksReorderActive', { active: value });

                // Focus the bookmarks list if reordering is activated
                if (value === true) {
                    jQuery('#sammio-bookmarks__list').focus();
                }
                
                // Show bookmarks list if in mobile mode
                if (this.isMobile) {
                    this.getDrawerStatus(this.drawerStatus = !this.drawerStatus);
                }
            },
            onClickDownload() {
                this.downloadButtonClicked = true
                this.$store.dispatch('setLoaderState', true)
                const storableBookmarks = getStorableBookmarks(this.getBookmarks, this.getBookmarkName)
                http.postWithBlobResponse('/get-pdf', this.$store.state.portletId, storableBookmarks)
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/pdf' })
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        const contentDisposition = response.headers['content-disposition'].split("=")
                        link.download = contentDisposition[1].replaceAll('"', '')
                        link.click()
                        URL.revokeObjectURL(link.href)
                        this.downloadButtonClicked = false
                        this.$store.dispatch('setLoadStatus', true)

                        setTimeout(()=> {
                          this.$store.dispatch('setLoaderState', false)
                        },3000)


                    })
                    .catch(error => {
                        this.error = true
                        this.$store.dispatch('setErrorMessages', { hasErrors: true, data: { type: 'bookmarks', code: '', text: i18n.t('sammio.errors.common_error') } })
                    })
            },
            onClickShare() {
                if (this.isRouteBookmarks) {
                    if (this.getBookmarksShortUrl === '') {
                        this.shareButtonClicked = true
                        this.$store.dispatch('saveBookmarks')
                    } else {

                        this.showShareTooltip = true
                        setTimeout(() => {
                          this.$refs.shareCopyButton.$el.focus()
                        },500)

                    }
                } else {
                    this.showShareTooltip = true
                    setTimeout(() => {
                      this.$refs.shareCopyButton.$el.focus()
                    },500)
                }
            },
            getDrawerStatus (event)  {
                this.$emit('drawer', event)
                this.drawerStatus = !event
            },
            printPage() {
                window.print()
            },
            onClickCopy() {
                if (!this.copyButtonClicked) {
                    this.$refs.shareCopyInput.select();
                    document.execCommand('copy');
                }
                this.copyButtonClicked = true
                let context = this
                this.timeoutHandle = window.setTimeout(function() {
                    context.showShareTooltip = false
                    context.$refs.buttonShare.$el.focus()
                    context.copyButtonClicked = false
                }, 3000)
            },
            selectText(event) {
                const text = event.target.value
                event.target.setSelectionRange(0, text.length)
            },
            onClickOutsideModal() {
                this.showShareTooltip = false
                this.copyButtonClicked = false
                if (this.timeoutHandle !== '') {
                    window.clearTimeout(this.timeoutHandle)
                    this.timeoutHandle = ''
                }
            }
        },
        watch: {
            getBookmarksShortUrl(value) {
                if (this.shareButtonClicked) {
                    if (value !== '') {
                        this.shareButtonClicked = false
                        this.showShareTooltip = true
                    }
                }
            },
            $route(to, from) {
                this.copyButtonClicked = false
            }
        }
    }
</script>

<style scoped>

</style>
